export const REQUEST_ID_HEADER = 'X-Request-Id'

export function buildRequestId () {
  return 'req_' + Date.now() + '_' + buildRandomPart()
}

export function extractRequestId (headers) {
  if (!headers || typeof headers !== 'object') {
    return ''
  }
  if (headers[REQUEST_ID_HEADER]) {
    return headers[REQUEST_ID_HEADER]
  }
  if (headers['x-request-id']) {
    return headers['x-request-id']
  }
  const keys = Object.keys(headers)
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (key && key.toLowerCase() === 'x-request-id') {
      return headers[key]
    }
  }
  return ''
}

export function attachRequestId (config) {
  config = config || {}
  const headers = config.headers || {}
  config.headers = headers

  const requestId = extractRequestId(headers) || buildRequestId()
  headers[REQUEST_ID_HEADER] = requestId
  config.request_id = requestId

  return requestId
}

function buildRandomPart () {
  if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
    const values = new Uint32Array(2)
    window.crypto.getRandomValues(values)
    return values[0].toString(16) + values[1].toString(16)
  }
  return Math.random().toString(16).slice(2)
}
